import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ArrowLeftStopLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m10 12-.354-.354-.353.354.353.354zm10 .5a.5.5 0 0 0 0-1zm-4.354-6.854-6 6 .708.708 6-6zm-6 6.708 6 6 .708-.708-6-6zM10 12.5h10v-1H10z" }),
            React.createElement("path", { stroke: "currentColor", d: "M4 5v14" })));
}
const ArrowLeftStopLight = forwardRef(_ArrowLeftStopLight);
export { ArrowLeftStopLight };
